import { render, staticRenderFns } from "./updPassword.vue?vue&type=template&id=304a9051&scoped=true"
import script from "./updPassword.vue?vue&type=script&lang=js"
export * from "./updPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a9051",
  null
  
)

export default component.exports